module.exports = __webpack_public_path__ + "static/media/cardOne.54e7a6b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowOne/cardOne.jpg
// module id = 16
// module chunks = 0